module.exports = __webpack_public_path__ + "img/prykarpattyaoblenergo_presentation.11d4c684.png";